import React, { useEffect, useState } from 'react'
import { api } from '../../lib/api'

function unwrap(res) {
  return res?.data?.data ?? res?.data ?? null
}

/**
 * 게시된 정책 문서가 있으면 HTML로 렌더하고, 없거나 오류 시 fallback 노드를 보여준다.
 */
export default function LegalPolicyPublicSection({ docCode, fallback }) {
  const [phase, setPhase] = useState('loading')
  const [remote, setRemote] = useState(null)

  useEffect(() => {
    let cancelled = false
    setPhase('loading')
    setRemote(null)
    api
      .get(`/legal-policies/public/${encodeURIComponent(docCode)}`)
      .then((res) => {
        const d = unwrap(res)
        const html = d?.bodyHtml
        if (cancelled) return
        if (typeof html === 'string' && html.trim().length > 0) {
          setRemote(d)
          setPhase('remote')
        } else {
          setPhase('fallback')
        }
      })
      .catch(() => {
        if (!cancelled) setPhase('fallback')
      })
    return () => {
      cancelled = true
    }
  }, [docCode])

  if (phase === 'loading') {
    return <p className="text-sm text-slate-500">문서를 불러오는 중입니다…</p>
  }

  if (phase === 'remote' && remote) {
    return (
      <div className="legal-policy-remote">
        <p className="text-sm text-slate-500">
          버전: {remote.versionLabel || '-'}
          {remote.effectiveDate ? ` · 시행일 ${remote.effectiveDate}` : ''}
        </p>
        {remote.title ? <p className="mt-2 text-base font-semibold text-slate-900">{remote.title}</p> : null}
        {/* 운영자 입력 HTML — 신뢰 경로(CMS). 클라이언트 sanitize 없음 */}
        <div
          className="mt-6 space-y-4 text-sm leading-relaxed text-slate-800 [&_h2]:text-base [&_h2]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_a]:font-semibold [&_a]:text-brand-navy [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: remote.bodyHtml }}
        />
      </div>
    )
  }

  return <>{fallback}</>
}
